export default __webpack_public_path__ + "static/media/DINPro-Light.0d2caef3.ttf";